import { render, staticRenderFns } from "./PagesLayout.vue?vue&type=template&id=72618d6a&scoped=true&lang=pug&"
import script from "./PagesLayout.vue?vue&type=script&lang=ts&"
export * from "./PagesLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72618d6a",
  null
  
)

export default component.exports